import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import SpiritualDisclaimer from "../components/SpiritualDisclaimer";

const FAQS = [
  { q: "How do online readings work?", a: "After booking, you'll receive a confirmation. Online readings are conducted by video or phone — we'll send the link and prep notes ahead of time." },
  { q: "What should I prepare?", a: "Bring an open mind and any specific questions. There's no need for special items on your end — The Lion Chief prepares the space." },
  { q: "Can I request a service not listed here?", a: "Absolutely. Reach out via the Contact page for a custom spiritual service quote." },
  { q: "What is your refund policy?", a: "Sessions can be rescheduled with 24-hour notice. Custom physical products are non-refundable once shipped." },
];

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  const byCategory = services.reduce((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-7xl mx-auto" data-testid="services-page">
      <div className="overline mb-4">Our Services</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Spiritual services designed with intention.</h1>
      <p className="mt-6 text-white/70 max-w-2xl text-lg">
        Choose from tarot readings, consultations, house cleansings, protection work, and custom spiritual services. Every offering is rooted in tradition, lived experience, and care.
      </p>

      <SpiritualDisclaimer />

      <div className="mt-16 space-y-16">
        {Object.entries(byCategory).map(([category, items]) => (
          <div key={category}>
            <h2 className="font-serif text-3xl mb-8 text-[#D4AF37]">{category}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((s) => (
                <div key={s.id} className="bg-[#0A0A0A] border border-white/5 hover:border-[#D4AF37]/40 p-8 transition-colors flex flex-col" data-testid={`service-card-${s.id}`}>
                  <h3 className="font-serif text-2xl">{s.name}</h3>
                  <p className="text-white/60 mt-3 leading-relaxed flex-1">{s.description}</p>
                  <div className="mt-6 flex items-center justify-between text-sm">
                    <span className="overline text-[#D4AF37]">{s.duration}</span>
                    <span className="font-serif text-xl">{s.price > 0 ? `$${s.price.toFixed(2)}` : "Custom"}</span>
                  </div>
                  <div className="mt-6 flex gap-3">
                    {s.category === "House Calls" ? (
                      <Link to="/house-calls" className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] border border-[#D4AF37] px-4 py-2 hover:bg-[#D4AF37] hover:text-black" data-testid={`service-${s.id}-request-btn`}>Request</Link>
                    ) : s.price > 0 ? (
                      <Link to={`/book-reading?service=${s.id}`} className="text-xs uppercase tracking-[0.2em] text-white bg-[#8B0000] hover:bg-[#A50000] px-4 py-2" data-testid={`service-${s.id}-book-btn`}>Book</Link>
                    ) : (
                      <Link to="/contact" className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] border border-[#D4AF37] px-4 py-2 hover:bg-[#D4AF37] hover:text-black">Contact for Quote</Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-24" data-testid="services-faq">
        <div className="overline mb-3">Common Questions</div>
        <h2 className="font-serif text-3xl mb-8">Frequently Asked</h2>
        <Accordion type="single" collapsible className="space-y-2">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`f-${i}`} className="border border-white/10 px-6">
              <AccordionTrigger className="font-serif text-lg hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
